import {
  mdiAccount,
  mdiAccountCircleOutline,
  mdiAccountCheck,
  mdiAccountEdit,
  mdiAccountMultiple,
  mdiAccountRemove,
  mdiAlert,
  mdiAmbulance,
  mdiArrowLeftRight,
  mdiChat,
  mdiClose,
  mdiDelete,
  mdiExport,
  mdiEye,
  mdiEyeOff,
  mdiFaceAgent,
  mdiFinance,
  mdiGlasses,
  mdiInformation,
  mdiLock,
  mdiMagnify,
  mdiMail,
  mdiMapMarker,
  mdiMedicalBag,
  mdiPaperclip,
  mdiPharmacy,
  mdiPhone,
  mdiPlaylistEdit,
  mdiPlus,
  mdiPrescription,
  mdiReceipt,
  mdiSale,
  mdiSend,
  mdiCog,
  mdiSigma,
  mdiSkype,
  mdiSpotlightBeam,
  mdiTemperatureCelsius,
  mdiTooltipAccount,
  mdiViewDashboard,
  mdiViewList,
} from "@mdi/js";

export const Icon = {
  account: mdiAccount,
  accountCircleOutline: mdiAccountCircleOutline,
  accountCheck: mdiAccountCheck,
  accountEdit: mdiAccountEdit,
  accountMultiple: mdiAccountMultiple,
  accountRemove: mdiAccountRemove,
  alert: mdiAlert,
  ambulance: mdiAmbulance,
  arrowLeftRight: mdiArrowLeftRight,
  chat: mdiChat,
  close: mdiClose,
  delete: mdiDelete,
  edit: mdiPlaylistEdit,
  export: mdiExport,
  eye: mdiEye,
  eyeOff: mdiEyeOff,
  faceAgent: mdiFaceAgent,
  finance: mdiFinance,
  glasses: mdiGlasses,
  info: mdiInformation,
  lock: mdiLock,
  magnify: mdiMagnify,
  mail: mdiMail,
  mapMarker: mdiMapMarker,
  medicalBag: mdiMedicalBag,
  paperclip: mdiPaperclip,
  pharmacy: mdiPharmacy,
  phone: mdiPhone,
  plus: mdiPlus,
  prescription: mdiPrescription,
  receipt: mdiReceipt,
  sale: mdiSale,
  send: mdiSend,
  settings: mdiCog,
  sigma: mdiSigma,
  skype: mdiSkype,
  spotlightBeam: mdiSpotlightBeam,
  temperatureCelsius: mdiTemperatureCelsius,
  tooltipAccount: mdiTooltipAccount,
  viewDashboard: mdiViewDashboard,
  viewList: mdiViewList,
};
